import { useEffect, useState } from "react";

const width = {
  no: "w-[3.5rem]",
  nama: "w-[24rem]",
  quantity: "w-[15rem]",
  // total: "w-[15rem]",
};

const ReportTemplateSummary = (props) => {
  const { list, listRaw, groupNames, groupMap } = props;
  const [rows, setRows] = useState([]);

  const [totalQTY, setTotalQTY] = useState(0);
  const [totalHarga, setTotalHarga] = useState(0);

  useEffect(() => {
    const _rows = [];
    let no = 1;

    let total_qty = 0;
    let total_harga = 0;

    for (let groupName of groupNames) {
      const group = groupMap[groupName];
      if (group) {
        const product = group.group_data;

        const row = {
          no: no++,
          nama: product.product_name,
          quantity: group.total_quantity,
          price: product.price,
          total_harga: group.total_quantity * product.price
        };

        _rows.push(row);

        total_qty += group.total_quantity;
        total_harga += row.total_harga;
      }
    }

    setRows(_rows);
    setTotalQTY(total_qty);
    setTotalHarga(total_harga);
  }, [groupNames, groupMap]);

  return (
    <table>
      <thead>
        <tr className="row-start-start text-sm w-[42.5rem] bg-zinc-100 font-semibold text-slate-800">
          <td className="border-zinc-300 border w-full px-2 pb-2 pt-3">
            SUMMARY LAPORAN
          </td>
        </tr>

        <tr className="row-start-start text-sm bg-zinc-100 font-semibold text-slate-800">
          <td className={`${width.no} row-center-center border border-t-0 px-2 pb-2 pt-3`}>
            #
          </td>
          <td className={`${width.nama} border border-t-0 border-l-0 px-2 pb-2 pt-3`}>
            PRODUK
          </td>
          <td className={`${width.quantity} border border-t-0 border-l-0 text-right px-2 pb-2 pt-3`}>
            JUMLAH (QTY)
          </td>
          {/* <td className={`${width.total} border border-t-0 border-l-0 text-right px-2 pb-2 pt-3`}>
            TOTAL HARGA
          </td> */}
        </tr>
      </thead>

      <tbody>
        {rows &&
          rows.length > 0 &&
          rows.map((el) => {
            return (
              <tr
                key={`summary-${el.no}`}
                className="row-start-start w-full text-sm text-slate-700 !items-stretch"
              >
                <td
                  className={`${width.no} row-center-center border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
                >
                  {el.no}
                </td>
                <td
                  className={`${width.nama} row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.nama}
                </td>
                <td
                  className={`${width.quantity} col-start-end row-start-start border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
                >
                  {el.quantity}
                </td>
                {/* <td className={`${width.total} text-right border border-l-0 border-t-0 px-2 pt-2 pb-1`}>
                  Rp {el.total_harga.toLocaleString("id-ID")}
                </td> */}
              </tr>
            );
          })}
      </tbody>
      <tfoot>
        <tr className="row-start-start text-sm w-full bg-zinc-100 font-semibold text-slate-800 ">
          <td
            className={`row-end-start w-[27.5rem] border-zinc-300 border border-t-0 px-2 h-full pb-2 pt-3 `}
          >
            GRANDTOTAL
          </td>
          <td
            className={`row-end-start ${width.quantity} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            {totalQTY}
          </td>
          {/* <td
            className={`row-end-start ${width.total} border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `}
          >
            Rp {totalHarga.toLocaleString("id-ID")}
          </td> */}
        </tr>
      </tfoot>
    </table>
  );
};

export default ReportTemplateSummary;
